export type LifecycleLinkPrefetch = boolean | null | undefined

export const resolveLifecycleLinkPrefetch = (
  prefetch: LifecycleLinkPrefetch,
  shouldDefer: boolean
): LifecycleLinkPrefetch => (shouldDefer ? false : prefetch)
